import {useTranslation} from 'react-i18next';

import {Box, TextField, useTheme} from '@mui/material';

import {InfoBanner} from '../../../../../../components/InfoBanner/InfoBanner';
import {getFieldStyle} from '../../../../../../layouts/theme/FieldStyles';


export interface Props {
  responsibilities: string;
  senioritySignals: string;
  onResponsibilitiesChange: (value: string) => void;
  onSenioritySignalsChange: (value: string) => void;
}

export const WorkforceProfileWizardResponsibilitiesStep = ({
  responsibilities,
  senioritySignals,
  onResponsibilitiesChange,
  onSenioritySignalsChange,
}: Props) => {
  const theme = useTheme();
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.sections.responsibilities'});

  return (
    <Box>
      <InfoBanner text={t('guidance')} sx={{mb: 2}} />
      <TextField
        fullWidth
        multiline
        minRows={3}
        size='small'
        label={t('responsibilities')}
        value={responsibilities}
        onChange={(event) => onResponsibilitiesChange(event.target.value)}
        sx={{...getFieldStyle(theme), mb: 2}}
      />
      <TextField
        fullWidth
        multiline
        minRows={2}
        size='small'
        label={t('senioritySignals')}
        value={senioritySignals}
        onChange={(event) => onSenioritySignalsChange(event.target.value)}
        sx={getFieldStyle(theme)}
      />
    </Box>
  );
};
